import { useState, useEffect } from 'react';

/**
 * a React hook to detect if the window is online
 * @param {function} props.onOnline - optional function to run when online
 * @param {function} props.onOffline - optional function to run when offline
 */
const useIsOnline = (props) => {
    const [isOnline, setIsOnline] = useState(true);
    useEffect(() => {
        const onIsOnline = () => {
            var _a;
            setIsOnline(true);
            (_a = props === null || props === void 0 ? void 0 : props.onOnline) === null || _a === void 0 ? void 0 : _a.call(props);
        };
        const onIsOffline = () => {
            var _a;
            setIsOnline(false);
            (_a = props === null || props === void 0 ? void 0 : props.onOffline) === null || _a === void 0 ? void 0 : _a.call(props);
        };
        window.addEventListener('online', onIsOnline);
        window.addEventListener('offline', onIsOffline);
        return () => {
            window.removeEventListener('online', onIsOnline);
            window.removeEventListener('offline', onIsOffline);
        };
    }, []);
    return isOnline;
};

export { useIsOnline };
